import React from 'react';
import { DynamicRemoteComponent } from '@cnx-saas/common-fe';
import federatedModules from '../../federated-modules.json';

export type DynamicRemoteFederatedComponentProps = {
  exposedFrom: string;
  dependencies?: string[];
};

export function DynamicRemoteFederatedComponent(
  props: DynamicRemoteFederatedComponentProps,
) {
  return (
    <DynamicRemoteComponent
      exposedFrom={props.exposedFrom}
      dependencies={props.dependencies}
      dynamicRemotesConfig={federatedModules.dynamicRemotes}
    />
  );
}
